export default __webpack_public_path__ + "static/media/alphabet-yellow-a.9dc73f53.png";